import axios from "axios";

export const fetchAreas = async () => {
    const response = await axios.get("api/area/");
    const areas = response.data;
    return areas;
}